module.exports = __webpack_public_path__ + "static/logo_campaign-0ba6c2004646f660790c1c16a1b6f1dd.png";